import { api } from "./client";

const BASE_URL = "/trip-expenses/";

export const getExpenses = async (page = 1, pageSize = 50, tripId = null) => {
  const params = { page, page_size: pageSize };
  if (tripId) params.trip = tripId;
  return api.get(BASE_URL, { params });
};

export const createExpense = (payload) => api.post(BASE_URL, payload);

export const deleteExpense = (id) => api.delete(`${BASE_URL}${id}/`);
